import React from "react"
import { Dropdown, DropdownButton } from "react-bootstrap"

import { isLTPM } from "../../../../components/shared_components_registration"
const registration = {
  new_dropdown_option: (intl) => (isLTPM ? intl.formatMessage({ id: "general.new" }) : "New"),
  original_dropdown_option: (intl) => (isLTPM ? intl.formatMessage({ id: "general.original" }) : "Original"),
}

export default function NewOriginalDropdown({ isNew, intl, onSelect, id }) {
  return (
    <DropdownButton
      id={id}
      variant={"outline-primary"}
      style={{ padding: "0" }}
      title={isNew ? registration.new_dropdown_option(intl) : registration.original_dropdown_option(intl)}
    >
      {[
        { key: "new", value: "New" },
        { key: "original", value: "Original" },
      ].map((info, i) => (
        <Dropdown.Item key={`${id}${i}`} onClick={(_) => onSelect(info["value"] === "New")}>
          {registration[`${info["key"]}_dropdown_option`](intl)}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  )
}
